import styled from "styled-components";

export const HomeContainer = styled.div`
  font-family: Arial, Helvetica, sans-serif;
  height: 75vh;
  color: rgb(80,80,80);
  font-size: 25px;
  z-index: 0; 
  display: flex;
  flex-direction: row;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    height: 100vh;
    margin-bottom: 100px;
  }
`
export const Wrap3 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 95px;
  gap: 40px; 
  @media (max-width: 768px) {
    margin-top: 50px; 
    width: 100%;
  }

`


export const LpButton = styled.div` 
  padding: 20px 40px;
  width: 400px;
  height: 66px;
  display: flex ;
  align-items: center;
  justify-content: center;
  border: ${props => props.btnType === "join" ? "3px solid #00B4CC" : "3px solid white"};
  border-radius: 35px;
  cursor: pointer;
  background-color: ${props => props.btnType === "cal" ? "#ffffff":"#00b4cc"  };
  color: ${props => props.btnType === "cal" ? "#00B4CC":"white"  };
  font-weight: bold;
  box-shadow: 0px 0px 15px #666666c0;

  &:hover{
    color: ${props => props.btnType === "cal" ? "#00B4CC":"white"  };
    background-color: ${props => props.btnType === "cal" ? "white":"#007180"  };
    border: ${props => props.btnType === "cal" ? "3px solid #00B4CC" : "3px solid #007180"};
    box-shadow: 3px 3px 7px rgb(179, 179, 179);
    transition: all .6s ;
  }
  @media (max-width: 768px) {
    font-size: 15px;
    width: 550px;  
      
    &:hover{
      box-shadow: none;
    }
  }

 
`